import React, { useEffect, useState } from 'react';
import Content from "./service/Content";
import { setHeader } from "../../../../redux/actions/layout/interaction/action";
import { useDispatch } from "react-redux";
import { addTimekeepingCommonConfigApi } from "../../../../api/setting/timekeeping";
import dayjs from "dayjs";
import { t } from "i18next";
import { message } from "antd";

const TimeKeepingSetting = props => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        dispatch(setHeader(t("timeKeeping-setting.timeKeeping-setting.timeKeeping-setting"), null))
    }, [])

    const onFinish = (values) => {
        if (!Array.isArray(values.splitline)) {
            values = { ...values, splitline: [values.splitline] };
        }
        setLoading(true)
        values.timeclosingHour = dayjs(values?.time)?.hour();
        values.timeclosingMinute = dayjs(values?.time)?.minute();
        delete values.time;
        console.log("form", values);
        addTimekeepingCommonConfigApi(values).then(() => {
            message.success(t("tnp.button.messageUpdate")).then(() => { })
        }).finally(() => setLoading(false));
    }
    return (
        <Content
            mode={"update"}
            onFinish={onFinish}
            loading={loading}
        />
    );
};

TimeKeepingSetting.propTypes = {};

export default TimeKeepingSetting;
